// src/api/client.js
import api, { mediaUrl } from '../services/api';

// Re-export the configured axios client and helper used throughout the app.
// This indirection allows newer API modules (e.g. tenant-aware services) to
// live under src/api without forcing a sweeping refactor of legacy imports.
export { mediaUrl };
export default api;
